// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"2b8535c4","177":"027273dc","377":"6abb2db3","378":"edbddd7e","770":"65ec727f"}[chunkId] + ".chunk.css";
};